import { compose } from 'recompose'
import fetchClientInfoOnMountAndUpdate from 'src/composables/fetchClientInfoOnMountAndUpdate'
import withLoadedFromHomesAndClients from 'src/composables/withLoadedFromHomesAndClients'

const NavigationContainer = compose(
  fetchClientInfoOnMountAndUpdate,
  withLoadedFromHomesAndClients
)

export default NavigationContainer
